import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// ===== Inquiry API =====
export const submitInquiry = async (inquiry) => {
  const { data } = await api.post('/inquiries', inquiry);
  return data;
};

// ===== Admin API =====
const ADMIN_TOKEN_KEY = 'ikarus_admin_token';

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(ADMIN_TOKEN_KEY, token);

const adminHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminLogin = async (password) => {
  const { data } = await api.post('/admin/login', { password });
  setAdminToken(data.token);
  return data;
};

export const fetchInquiries = async () => {
  const { data } = await api.get('/admin/inquiries', { headers: adminHeaders() });
  return data;
};

export const updateInquiryStatus = async (id, status) => {
  const { data } = await api.patch(
    `/admin/inquiries/${id}`,
    { status },
    { headers: adminHeaders() }
  );
  return data;
};

export const deleteInquiry = async (id) => {
  const { data } = await api.delete(`/admin/inquiries/${id}`, { headers: adminHeaders() });
  return data;
};

export default api;
